import { render, staticRenderFns } from "./CombinePackage.vue?vue&type=template&id=6ad9497c"
import script from "./CombinePackage.vue?vue&type=script&lang=js"
export * from "./CombinePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports